<template>
  <v-app-bar color="#76777a" app class="white--text" :height="appbarHeight">
    <div v-if="!noLogo" :style="'height:' + appbarHeight + 'px'" class="d-none d-sm-flex justify-center align-center mr-6">
      <opq-logo :height="appbarHeight * 0.667" />
    </div>
    <v-toolbar-title> <slot></slot> </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-if="!noLinkToPortal" color="#3a3838" class="font-weight-bold white--text aleo d-none d-sm-flex" link :href="urlPortail">
      <v-icon class="mr-3">mdi-arrow-left</v-icon> Retour au portail
    </v-btn>
  </v-app-bar>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
export default {
  mixins: [AppbarBase],
  props: {
    noLogo: {
      type: Boolean,
      default: false
    },
    noLinkToPortal: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>